module.exports = __webpack_public_path__ + "assets/img/dailyMission.da055b1e.png";